import styled, { css } from "styled-components";

import EGTDigitalBGSecond from "@pages/casino/assets/backgrounds/egtdigital-header-second.webp";
import EGTDigitalBG from "@pages/casino/assets/backgrounds/egtdigital-header.webp";
import PokerBG from "@pages/casino/assets/backgrounds/poker-bg.png";
import PragmaticplayBGSecond from "@pages/casino/assets/backgrounds/pragmatic-header-second.webp";
import PragmaticplayBG from "@pages/casino/assets/backgrounds/pragmatic-header.webp";
import ProviderHeaderBGSecond from "@pages/casino/assets/backgrounds/provider-header-second.webp";
import ProviderHeaderBG from "@pages/casino/assets/backgrounds/provider-header.webp";
import RuletBG from "@pages/casino/assets/backgrounds/rulet-header.png";
import TableBG from "@pages/casino/assets/backgrounds/table-bg.png";

export const ProviderContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	@media (min-width: 1024px) {
		margin-top: 10px;
	}

	.header-container {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
	}
	.sticky-header {
		height: 100%;
		position: sticky;
		top: 0;
		z-index: 25;
		transition: background-color 0.4s ease-out;

		&:before {
			content: "";
			position: absolute;
			top: 0;
			left: calc(-50.5vw + 50%);
			width: 100vw;
			height: 100%;
			background: var(--dark-opacity);
			backdrop-filter: blur(10px);
			opacity: 0;
			z-index: -1;
			transform: translateY(-100%);
			transition:
				background 0.3s ease-out,
				backdrop-filter 0.3s ease-out,
				opacity 0.3s ease-out,
				transform 0.3s ease-out;
		}
	}

	.sticky-header.sticked {
		&:before {
			content: "";
			position: absolute;
			top: 0;
			left: calc(-50.5vw + 50%);
			width: 100vw;
			height: 100%;
			background: var(--dark-opacity);
			backdrop-filter: blur(10px);
			opacity: 0.85;
			z-index: -1;
			transform: translateY(0);
			transition:
				background 0.3s ease-out,
				backdrop-filter 0.3s ease-out,
				opacity 0.3s ease-out,
				transform 0.1s ease-out;
		}
	}

	.sticky-header.sticked-enlarged {
		&:before {
			height: calc(100% + 10px);
		}
	}

	.breadcrumb.sticky-header {
		transition:
			background-color 0.4s ease-out 0s,
			transform 0.4s ease-out 0s;
	}

	.casino-filters.sticky-header {
		transition:
			background-color 0.4s ease-out 0.1s,
			transform 0.4s ease-out 0.1s;
	}

	.tags-filters.sticky-header {
		transition:
			background-color 0.4s ease-out 0.2s,
			transform 0.4s ease-out 0.2s;
	}

	.casino-filters {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		margin-bottom: 20px;

		& > div:first-child {
			padding: 0px 20px;
			@media (min-width: 430px) {
				padding: 0px 40px;
			}
			@media (min-width: 744px) {
				padding: 0px;
				justify-content: space-between;
			}
		}

		@media (min-width: 744px) {
			flex-direction: row;
			justify-content: space-between;
			padding: 0 20px;
		}

		@media (min-width: 1024px) {
			width: 890px;
			padding: 0;
			gap: 3px;
		}

		@media (min-width: 1280px) {
			width: 1250px;
			gap: 8px;
		}

		@media (min-width: 1600px) {
			width: 1434px;
		}

		#casino-filters-container {
			margin-top: 20px;
			margin-bottom: 0px;
			justify-content: flex-start;
			width: 100%;
			padding: 0 25px 0 20px;
			& > div {
				min-width: 110px;
			}

			@media (min-width: 430px) {
				padding: 0px 40px;
			}

			@media (min-width: 744px) {
				margin: 0px;
				padding: 0px;
				width: max-content;
			}

			@media (min-width: 1024px) {
				gap: 3px;
			}

			@media (min-width: 1280px) {
				gap: 10px;
			}
		}
	}

	.tags,
	.tags-filters,
	.breadcrumb {
		padding: 0px 20px;
		@media (min-width: 1024px) {
			width: 890px;
			padding: 0;
		}

		@media (min-width: 1280px) {
			width: 1250px;
		}

		@media (min-width: 1600px) {
			width: 1434px;
		}
	}

	.tags-filters {
		margin: -10px 0 10px 0;
		@media (min-width: 430px) {
			padding: 0 40px;
		}

		@media (min-width: 744px) {
			padding: 0 20px;
		}
		@media (min-width: 1600px) {
			padding: 0;
		}
	}

	.breadcrumb {
		padding: 12px 20px;
		@media (min-width: 1024px) {
			padding: 12px 0px;
		}
	}

	.background-card {
		height: 76px;
		margin-bottom: 20px;
		border-radius: 0px;
		background-repeat: no-repeat;
		background-position: center;

		@media (min-width: 425px) {
			height: 108px;
		}
		@media (min-width: 744px) {
			height: 108px;
		}
		@media (min-width: 1280px) {
			height: 135px;
		}
		@media (min-width: 1600px) {
			max-height: 204px;
			height: 180px;
		}
	}
	${({ hasMarsProviderBg }) =>
		hasMarsProviderBg &&
		css`
			.casino-filters {
				@media (min-width: 1280px) {
					margin-top: 150px;
					top: 54px !important;
				}
			}

			.casino-filters {
				@media (min-width: 1579px) {
					margin-top: 150px;
					top: 64px !important;
				}
			}
			.background-card {
				height: 76px;
				margin-bottom: 20px;
				border-radius: 0px;
				background-repeat: no-repeat;
				background-position: center;
				background-blend-mode: multiply, normal;
				background-image: none;

				@media (min-width: 425px) {
					height: 108px;
				}
				@media (min-width: 744px) {
					height: 108px;
				}
				@media (min-width: 1280px) {
					height: 180px;
					position: absolute;
				}

				&::before {
					content: "";
					position: absolute;
					bottom: -1px;
					left: 0;
					width: 100%;
					height: 1px;
					background: linear-gradient(
						to right,
						rgba(0, 0, 0, 0),
						var(--main-color-dark),
						rgba(0, 0, 0, 0)
					);
				}
			}
		`};

	.allGames {
		background-image: url(${ProviderHeaderBGSecond});
		background-position: bottom;
	}

	.category {
		background-image: url(${TableBG});
		background-position: bottom;
	}

	.tournaments {
		background-image: url(${RuletBG});
	}

	.affiliate {
		background-image: url(${ProviderHeaderBGSecond});
	}

	.egtdigital {
		background-image: url(${EGTDigitalBGSecond});
	}

	.pragmaticplay {
		background-image: url(${PragmaticplayBGSecond});
	}

	${({ hasMarsProviderBg }) =>
		!hasMarsProviderBg &&
		css`
			.allGames {
				background-image: url(${PokerBG});
				background-position: bottom;
			}
			.affiliate {
				background-image: url(${ProviderHeaderBG});
			}
			.egtdigital {
				background-image: url(${EGTDigitalBG});
			}
			.pragmaticplay {
				background-image: url(${PragmaticplayBG});
			}
		`};
`;

export const GameContainer = styled.div.attrs(() => ({
	className: "game-container",
}))`
	width: 325px;
	padding: 0px 20px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
	gap: 10px;
	@media (min-width: 425px) {
		width: 390px;
	}
	@media (min-width: 570px) {
		width: 100%;
	}

	@media (min-width: 744px) {
		padding: 0 16px;
	}

	@media (min-width: 1024px) {
		width: 890px;
		padding: 0;
		justify-content: flex-start;
	}
	@media (min-width: 1280px) {
		width: 1250px;
	}

	@media (min-width: 1600px) {
		width: 1434px;
	}

	@media (min-width: 1024px) {
		#game-image-wrapper {
			.img-container {
				&::after {
					${() =>
						window.HOMEPAGE_AND_CASINO_PAGES_GAME_CARD_HAS_NO_SHADOW &&
						css`
							box-shadow: inset 0 0 7px 3px #1d0637d4;
							filter: drop-shadow(10px 10px 10px rgba(29, 10, 55, 1));
						`}
				}
			}
		}
	}
`;

export const BackgroundCardTitle = styled.div`
	color: var(--secondary-text-color);
	text-align: center;
	font-size: 12px;
	font-weight: 700;
	line-height: 12px;
	letter-spacing: 0.25px;
`;
